<template>
    <vx-card title="Страница восстановления снэпшотов" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/3">
                <div class="vx-col mb-1">
                    <div class="mt-1">
                        <label class="vs-input--label"> Интервал </label>
                        <date-picker :not-before="disabledBefore" :not-after="disabledAfter" :clearable="false" range
                            v-model="dateIntervalSnapshot" type="datetime" format="YYYY-MM-DD HH:mm"
                            placeholder="Интервал времени" :lang="'ru'" :firstDayOfWeek="1" class="date-p w-full">
                        </date-picker>
                    </div>
                </div>
            </div>
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input label="Id тизеров" v-model="form.adIds" placeholder="Введите через запятую"
                        class="mt-1 w-full" :danger="!!errors.adIds" :danger-text="errors.adIds" />
                </div>
            </div>
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input label="Id снэпшотов" v-model="form.snapshotIds" placeholder="Введите через запятую"
                        class="mt-1 w-full" :danger="!!errors.snapshotIds" :danger-text="errors.snapshotIds" />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2 mt-4">
            <div class="vx-col w-1/5">
                <div class="mt-1">
                    <label class="vs-input--label"> Восстановление статуса ротации </label>
                    <v-select :options="dicts.repairModesStatus" label="name" placeholder="Выберите режим"
                        class="w-full" v-bind:class="{ 'select-error': !!errors.repairModeStatus }" :reduce="x => x.id"
                        :clearable="false" v-model="form.repairModeStatus">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/5">
                <div class="mt-1">
                    <label class="vs-input--label"> Восстановление CTR, buyouts, clicks </label>
                    <v-select :options="dicts.repairModesCtr" label="name" placeholder="Выберите режим" class="w-full"
                        v-bind:class="{ 'select-error': !!errors.repairModeCtr }" :reduce="x => x.id" :clearable="false"
                        v-model="form.repairModeCtr">
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/4">
                <div class="mt-1">
                    <label class="vs-input--label"> Установка по-умолчанию CTR, buyouts, clicks</label>
                    <v-select :options="dicts.repairModesDefaultCtr" label="name" placeholder="Выберите режим"
                        class="w-full" v-bind:class="{ 'select-error': !!errors.repairModeDefaultCtr }"
                        :clearable="false" :reduce="x => x.id" v-model="form.repairModeDefaultCtr">
                    </v-select>
                </div>
            </div>
            <div v-if="form.repairModeDefaultCtr > 0" class="vx-col w-1/3 pt-4">
                <div v-for="(contentTypeRow, index) in dicts.contentTypes" :key="index" class="row">
                    <template>
                        <div class="vx-row">
                            <vs-input disabled :value="contentTypeRow.name" class="mt-3 w-1/3" />
                            <vs-input v-model="contentTypeRow.value" placeholder="Введите ctr" class="mt-3 ml-5 w-1/3"
                                type="number" />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2 mt-4">
            <div class="vx-col w-1/4">
                <div class="mt-1">
                    <vs-checkbox class="mt-3" icon="check" color="rgb(38, 187, 174)"
                        v-model="form.isSourceAdsByStatusNotSet">Объявления из выпавших</vs-checkbox>
                </div>
            </div>
            <div v-if="form.isSourceAdsByStatusNotSet" class="vx-col w-1/3">
                <div class="vx-col mb-1">
                    <div class="mt-1">
                        <date-picker :not-before="disabledBefore" :not-after="disabledAfter" :clearable="false" range
                            v-model="dateIntervalNotSet" type="datetime" format="YYYY-MM-DD HH:mm"
                            placeholder="Интервал времени" :lang="'ru'" :firstDayOfWeek="1" class="date-p w-full">
                        </date-picker>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2 mt-4">
            <div class="vx-col w-1/5">
                <div class="mt-1">
                    <vs-checkbox :disabled="form.isAutoCreateSnapshot" class="mt-3" icon="check"
                        color="rgb(38, 187, 174)" v-model="form.isEmulation">Эмуляция</vs-checkbox>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-checkbox :disabled="form.isEmulation" class="mt-3" icon="check" color="rgb(38, 187, 174)"
                        v-model="form.isAutoCreateSnapshot">После
                        восстановления создать активный снимок топа</vs-checkbox>
                </div>
            </div>
        </div>
        <vs-button class="mt-5 mr-2" color="success" @click="rollback()" type="filled"> Восстановить </vs-button>

        <vs-table stripe :data="items" max-items="10" class="mt-5">
            <template slot="header">
            </template>
            <template slot="thead">
                <vs-th class="vs-lg-3">
                    Объявление
                </vs-th>
                <vs-th class="vs-lg-1">
                    Интерес
                </vs-th>
                <vs-th class="vs-lg-1">
                    Old CTR
                </vs-th>
                <vs-th class="vs-lg-1">
                    New CTR
                </vs-th>
                <vs-th class="vs-lg-1">
                    ReasonCTR
                </vs-th>
                <vs-th class="vs-lg-1">
                    OldStatus
                </vs-th>
                <vs-th class="vs-lg-1">
                    NewStatus
                </vs-th>
                <vs-th class="vs-lg-1">
                    ReasonStatus
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.adId }}</vs-td>
                    <vs-td>{{ tr.interest }}</vs-td>
                    <vs-td>{{ tr.oldCTR }}</vs-td>
                    <vs-td>{{ tr.newCTR }}</vs-td>
                    <vs-td>{{ tr.reasonCTR }}</vs-td>
                    <vs-td>{{ tr.oldStatus }}</vs-td>
                    <vs-td>{{ tr.newStatus }}</vs-td>
                    <vs-td>{{ tr.reasonStatus }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';
import DatePicker from 'vue2-datepicker';

let startPeriod = new Date(2024, 3, 1); // Дата начала сохранения снэпшотов
let endPeriod = new Date().setDate(new Date().getDate()); // Максимальный период включая сегодня

export default {
    data() {
        return {
            disabledBefore: startPeriod,
            disabledAfter: endPeriod,
            dateIntervalSnapshot: undefined,
            dateIntervalNotSet: undefined,
            items: [],
            dicts: {
                contentTypes: [],
                repairModesStatus: [
                    { name: 'Выключено', id: 0 },
                    { name: 'На обучении', id: 1 },
                    { name: 'Попали', id: 2 },
                    { name: 'Smart', id: 3 },
                ],
                repairModesCtr: [
                    { name: 'Выключено', id: 0 },
                    { name: 'Для нулевых', id: 1 },
                    { name: 'Для всех', id: 2 },
                ],
                repairModesDefaultCtr: [
                    { name: 'Выключено', id: 0 },
                    { name: 'Для нулевых', id: 1 },
                    { name: 'Для всех', id: 2 },
                ],
            },
            form: {
                isEmulation: true,
                snapshotStartPeriod: this.$moment(endPeriod).format('YYYY-MM-DD 00:00'),
                snapshotEndPeriod: this.$moment(endPeriod).format('YYYY-MM-DD 23:59:59'),
                notSetStartPeriod: this.$moment(endPeriod).format('YYYY-MM-DD 00:00'),
                notSetEndPeriod: this.$moment(endPeriod).format('YYYY-MM-DD 23:59:59'),
                adIds: undefined,
                snapshotIds: undefined,
                repairModeStatus: undefined,
                repairModeCtr: undefined,
                repairModeDefaultCtr: undefined,
                isSourceAdsByStatusNotSet: false,
                isAutoCreateSnapshot: false,
            },
            errors: {
                topId: '',
                adIds: '',
                snapshotIds: '',
                repairModeStatus: '',
                repairModeCtr: '',
                repairModeDefaultCtr: ''
            }
        };
    },
    mounted() {
        this.setDefaultValues();
    },
    methods: {
        rollback() {
            console.log('Rollbacked!');
            var errorFields = this.validateFields();
            if (errorFields) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: errorFields,
                    color: 'warning'
                });
            }

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            let dict = Object.fromEntries(
                this.dicts.contentTypes.map(contentType => [contentType.id, contentType.value]));

                console.log(dict);

            const params = {
                snapshotStartPeriod: this.form.snapshotStartPeriod,
                snapshotEndPeriod: this.form.snapshotEndPeriod,
                notSetStartPeriod: this.form.notSetStartPeriod,
                notSetEndPeriod: this.form.notSetEndPeriod,
                adIds: this.form.adIds
                    ? this.form.adIds
                        .split(',')
                        .map(function (item) {
                            return parseInt(item.trim());
                        })
                        .filter(Number.isInteger)
                    : [],
                snapshotIds: this.form.snapshotIds
                    ? this.form.snapshotIds
                        .split(',')
                        .map(function (item) {
                            return parseInt(item.trim());
                        })
                        .filter(Number.isInteger)
                    : [],
                repairModeStatus: this.form.repairModeStatus,
                repairModeCtr: this.form.repairModeCtr,
                repairModeDefaultCtr: this.form.repairModeDefaultCtr,
                defaultCtrByContentType: dict,
                isEmulation: this.form.isEmulation,
                isAutoCreateSnapshot: this.form.isAutoCreateSnapshot,
                isSourceAdsByStatusNotSet: this.form.isSourceAdsByStatusNotSet
            };

            this.axios
                .all([
                    this.axios.post('machine-learning-snapshot/rollback', params)
                ])
                .then(
                    axios.spread((items) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.items = items.data;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка восстановления топа.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        loadDicts() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios.all([
                this.axios.get('machine-learning-snapshot/dicts', {}),
            ])
                .then(axios.spread((dicts) => {
                    this.dicts.contentTypes = dicts.data.contentTypes;
                }))
                .catch((err) => {
                    this.$vs.notify({
                        title: "Ошибка!",
                        text: "Ошибка загрузки фильтров.",
                        color: "danger",
                    });
                })
                .finally(() => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                });
        },
        setDefaultValues() {
            let today = this.$moment(endPeriod).format('YYYY-MM-DD ');

            this.timeStart = '00:00:00';
            this.timeEnd = '23:59:59';
            this.dateIntervalSnapshot = [today + this.timeStart, today + this.timeEnd];
            this.dateIntervalNotSet = [today + this.timeStart, today + this.timeEnd];

            // Тестовые значения
            if (this.$route.query.isTest) {
                this.form.adIds = '1,2,3,4';
                this.form.snapshotIds = '6,7,8,9';
                this.form.repairModeStatus = 1;
                this.form.repairModeCtr = 1;
                this.form.repairModeDefaultCtr = 1;
            }
        },
        validateFields() {
            let isContentTypeCtrEmpty = true;
            this.dicts.contentTypes.forEach((contentType) => {                
                if(!(contentType.value > 0))
                {
                    return 'CTR по умолчанию должен быть больше нуля';
                }

                if(contentType.value)
                {
                    isContentTypeCtrEmpty = false;
                }
            });

            if (this.form.repairModeDefaultCtr > 0 && isContentTypeCtrEmpty) {
                return 'Заполните CTR хотя бы для одного типа';
            }
        },
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    watch: {
        dateIntervalSnapshot: function (newTime) {
            this.form.snapshotStartPeriod = this.$moment(newTime[0]).format('YYYY-MM-DD HH:mm:ss');
            this.form.snapshotEndPeriod = this.$moment(newTime[1]).format('YYYY-MM-DD HH:mm:ss');
        },
        dateIntervalNotSet: function (newTime) {
            this.form.notSetStartPeriod = this.$moment(newTime[0]).format('YYYY-MM-DD HH:mm:ss');
            this.form.notSetEndPeriod = this.$moment(newTime[1]).format('YYYY-MM-DD HH:mm:ss');
        }
    },
    mounted() {
        this.loadDicts();
        this.setDefaultValues();
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'ML Снэпшоты';
    },
};
</script>
